/* cv-core.js | Conveyor Apparel | REDESIGN_SPEC 3.8, 5.3.1, 7.2
   Deferred, no libraries, loaded on every page from layout/theme.liquid. Public API (see cv-tokens.css header):
     window.cvTrack(name, params)          funnel events, trackCustom only
     window.cvSheet.open(dialog, opts)     history-aware sheet helper (Back and Esc close, focus returns, page inert)
     window.cvSheet.close(dialog)
     window.cvSheet.bind(dialog)           optional: wire close buttons and the backdrop before the first open
   Also in this file: menu and search sheets get the same Back-button behaviour, the bag link keeps an accurate
   aria-label, the desktop Themes panel, mailto: and tel: links for the plain-text email and phone in page, policy and
   footer text, and a tiny RUM reporter (LCP, CLS, INP). */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ------------------------------------------------------------------ events */
  function cvTrack(name, params) {
    params = params || {};
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('cv_' + name, params);
      }
    } catch (e) {}
    try {
      doc.dispatchEvent(new CustomEvent('cv:track', { detail: { name: name, params: params } }));
    } catch (e) {}
  }
  window.cvTrack = cvTrack;

  /* ------------------------------------------------------------------ sheets */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var hasModal = typeof window.HTMLDialogElement === 'function' && typeof window.HTMLDialogElement.prototype.showModal === 'function';
  var stack = []; // open sheets and sheet-like details, last = top

  function resolve(x) {
    return typeof x === 'string' ? doc.getElementById(x.replace(/^#/, '')) : x;
  }

  function fire(el, name, id) {
    try {
      el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { id: id } }));
    } catch (e) {}
  }

  function pushState(entry) {
    try {
      var prev = window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
      var next = {};
      for (var k in prev) next[k] = prev[k];
      next.cvSheet = entry.id;
      next.n = stack.length;
      window.history.pushState(next, '', window.location.href);
      entry.pushed = true;
    } catch (e) {
      entry.pushed = false;
    }
  }

  function bind(el) {
    el = resolve(el);
    if (!el || el.__cvBound) return;
    el.__cvBound = true;
    el.addEventListener('cancel', function (e) {
      // Esc on a native dialog: close through the helper so the animation and the history entry are handled
      e.preventDefault();
      close(el);
    });
    el.addEventListener('click', function (e) {
      if (e.target === el) {
        close(el); // backdrop
        return;
      }
      var btn = e.target.closest ? e.target.closest('[data-cv-close]') : null;
      if (btn && el.contains(btn)) {
        e.preventDefault();
        close(el);
      }
    });
  }

  function fallbackOpen(el, entry) {
    el.setAttribute('open', '');
    el.setAttribute('aria-modal', 'true');
    if (!el.getAttribute('role')) el.setAttribute('role', 'dialog');
    var scrim = doc.createElement('div');
    scrim.className = 'cv-scrim';
    scrim.addEventListener('click', function () { close(el); });
    doc.body.appendChild(scrim);
    entry.scrim = scrim;
    if (el.parentNode !== doc.body) doc.body.appendChild(el);
    entry.inerted = [];
    Array.prototype.forEach.call(doc.body.children, function (n) {
      if (n !== el && n !== scrim && n.tagName !== 'SCRIPT' && !n.hasAttribute('inert')) {
        n.setAttribute('inert', '');
        n.setAttribute('aria-hidden', 'true');
        entry.inerted.push(n);
      }
    });
    entry.keydown = function (e) {
      if (e.key === 'Escape') {
        close(el);
        return;
      }
      if (e.key !== 'Tab') return;
      var f = el.querySelectorAll(FOCUSABLE);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && doc.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    doc.addEventListener('keydown', entry.keydown);
  }

  function fallbackClose(el, entry) {
    el.removeAttribute('open');
    el.removeAttribute('aria-modal');
    if (!entry) return;
    if (entry.scrim && entry.scrim.parentNode) entry.scrim.parentNode.removeChild(entry.scrim);
    (entry.inerted || []).forEach(function (n) {
      n.removeAttribute('inert');
      n.removeAttribute('aria-hidden');
    });
    if (entry.keydown) doc.removeEventListener('keydown', entry.keydown);
  }

  function open(el, opts) {
    el = resolve(el);
    if (!el || el.__cvOpen) return;
    opts = opts || {};
    bind(el);
    var entry = {
      el: el,
      id: el.id || 'sheet',
      trigger: opts.trigger || doc.activeElement,
      onClose: opts.onClose
    };
    el.__cvOpen = entry;
    stack.push(entry);
    pushState(entry);
    root.classList.add('cv-lock');
    if (hasModal && typeof el.showModal === 'function') {
      try { el.showModal(); } catch (e) { fallbackOpen(el, entry); }
    } else {
      fallbackOpen(el, entry);
    }
    // two frames so the slide-in transition runs from the closed position
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { el.classList.add('is-in'); });
    });
    var init = el.querySelector('[data-cv-initial]');
    if (init) {
      try { init.focus({ preventScroll: true }); } catch (e) {}
    }
    fire(el, 'cv:sheet-open', entry.id);
  }

  function finish(entry) {
    var el = entry.el;
    if (hasModal && typeof el.close === 'function' && el.tagName === 'DIALOG') {
      try { el.close(); } catch (e) {}
    }
    fallbackClose(el, entry);
    if (!stack.length) root.classList.remove('cv-lock');
    var t = entry.trigger;
    if (t && typeof t.focus === 'function' && doc.documentElement.contains(t)) {
      try { t.focus({ preventScroll: true }); } catch (e) {}
    }
    if (typeof entry.onClose === 'function') {
      try { entry.onClose(el); } catch (e) {}
    }
    fire(el, 'cv:sheet-close', entry.id);
  }

  function closeNow(entry) {
    var i = stack.indexOf(entry);
    if (i > -1) stack.splice(i, 1);
    var el = entry.el;
    delete el.__cvOpen;
    el.classList.remove('is-in');
    if (reduced()) finish(entry);
    else window.setTimeout(function () { finish(entry); }, 290);
  }

  function close(el) {
    el = resolve(el);
    var entry = el && el.__cvOpen;
    if (!entry) return;
    var st = window.history.state;
    if (entry.pushed && st && st.cvSheet === entry.id) {
      // the browser Back path does the real close (popstate below); one code path, one history entry
      entry.pushed = false;
      window.history.back();
      return;
    }
    closeNow(entry);
  }

  window.addEventListener('popstate', function (e) {
    var depth = e.state && e.state.cvSheet ? e.state.n : 0;
    while (stack.length > depth) {
      var top = stack[stack.length - 1];
      if (top.details) {
        stack.pop();
        top.closer();
      } else {
        closeNow(top);
      }
    }
  });

  window.cvSheet = { open: open, close: close, bind: bind };

  /* Dawn's details-based surfaces (menu drawer, search modal) get the same Back-button behaviour.
     isOpen() reports the open state, closeUI() closes it the way Dawn does, target+attr is what changes when it opens */
  function bindDetails(id, isOpen, closeUI, target, attr) {
    if (!target || !window.MutationObserver) return;
    var entry = null;
    var closer = function () {
      entry = null;
      closeUI();
    };
    new MutationObserver(function () {
      var now = isOpen();
      if (now && !entry) {
        entry = { id: id, details: true, closer: closer, pushed: false };
        stack.push(entry);
        pushState(entry);
      } else if (!now && entry) {
        var e = entry;
        entry = null;
        var i = stack.indexOf(e);
        if (i > -1) {
          // closed from the UI (X, link, Esc): pop our history entry without re-closing anything
          stack.splice(i, 1);
          var st = window.history.state;
          if (e.pushed && st && st.cvSheet === id) window.history.back();
        }
      }
    }).observe(target, { attributes: true, attributeFilter: [attr] });
  }

  function initDetailsSheets() {
    var drawer = doc.querySelector('header-drawer');
    var dd = drawer && drawer.querySelector('details');
    if (dd) {
      var summary = dd.querySelector('summary');
      var closeMenu = function () {
        if (typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(new KeyboardEvent('keyup', { code: 'Escape' }), summary);
        }
      };
      // 'menu-opening' is added right after open and removed the moment the close starts (Dawn's own timing)
      bindDetails('cv-menu', function () { return dd.classList.contains('menu-opening'); }, closeMenu, dd, 'class');
    }
    var sm = doc.querySelector('.cv-hdr details-modal');
    var sd = sm && sm.querySelector('details');
    if (sd) {
      bindDetails('cv-search', function () { return sd.hasAttribute('open'); }, function () {
        if (typeof sm.close === 'function') sm.close(false);
      }, sd, 'open');
    }
  }

  /* ------------------------------------------------------------------ header bits */
  function initBagLabel() {
    var a = doc.getElementById('cart-icon-bubble');
    if (!a || !window.MutationObserver) return;
    var set = function () {
      var n = 0;
      var b = a.querySelector('.cart-count-bubble [aria-hidden="true"]');
      if (b) n = parseInt(b.textContent, 10) || 0;
      else {
        var hidden = a.querySelector('.cart-count-bubble .visually-hidden');
        if (hidden) n = parseInt(hidden.textContent, 10) || 0;
      }
      a.setAttribute('aria-label', n > 0 ? 'Bag, ' + n + (n === 1 ? ' item' : ' items') : 'Bag');
    };
    set();
    new MutationObserver(set).observe(a, { childList: true, subtree: true, characterData: true });
  }

  function initMega() {
    var btn = doc.querySelector('[data-cv-mega]');
    var panel = btn && doc.getElementById(btn.getAttribute('aria-controls'));
    if (!btn || !panel) return;
    var setOpen = function (v) {
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (v) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    };
    btn.addEventListener('click', function () {
      setOpen(btn.getAttribute('aria-expanded') !== 'true');
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        btn.focus();
      }
    });
    doc.addEventListener('click', function (e) {
      if (btn.getAttribute('aria-expanded') === 'true' && !panel.contains(e.target) && !btn.contains(e.target)) setOpen(false);
    });
    panel.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !panel.contains(e.relatedTarget) && e.relatedTarget !== btn) setOpen(false);
    });
  }

  /* ------------------------------------------------------------------ contact links in typed text
     The support email and the +91 number are plain text in the page and policy bodies (typed in Shopify admin) and in the
     footer contact line, so a phone cannot tap them. At load, wrap each email address and each number that starts with + in
     a mailto: or tel: link. Only text inside .rte or the footer legal block, never inside a link, code, pre, script or button. */
  function initContactLinks() {
    if (!doc.createTreeWalker) return;
    var roots = doc.querySelectorAll('main .rte, .cv-ft__legal');
    if (!roots.length) return;
    var re = /[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}|\+\d{1,3}[  .-]?\d[\d  .-]{6,14}\d/g;
    var skip = /^(A|SCRIPT|STYLE|TEXTAREA|CODE|PRE|BUTTON|NOSCRIPT)$/;
    var found = [];
    Array.prototype.forEach.call(roots, function (root) {
      var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('@') === -1 && n.nodeValue.indexOf('+') === -1) continue;
        var ok = true;
        for (var p = n.parentNode; p && p !== root; p = p.parentNode) {
          if (skip.test(p.nodeName)) { ok = false; break; }
        }
        if (ok) found.push(n);
      }
    });
    found.forEach(function (node) {
      if (!node.parentNode) return; // a .rte nested in another .rte lists the same text node twice; the first pass already replaced it
      var text = node.nodeValue;
      var frag = doc.createDocumentFragment();
      var last = 0;
      var m;
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        var a = doc.createElement('a');
        a.href = m[0].indexOf('@') > -1 ? 'mailto:' + m[0] : 'tel:+' + m[0].replace(/\D/g, '');
        a.textContent = m[0];
        if (m.index > last) frag.appendChild(doc.createTextNode(text.slice(last, m.index)));
        frag.appendChild(a);
        last = m.index + m[0].length;
      }
      if (!last) return;
      if (last < text.length) frag.appendChild(doc.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  /* ------------------------------------------------------------------ RUM (spec 7.2): LCP, CLS, INP, template, iab flag */
  function initRum() {
    if (!('PerformanceObserver' in window)) return;
    var m = { lcp: null, cls: 0, inp: null };
    var sent = false;
    var obs = function (type, cb, extra) {
      try {
        var po = new PerformanceObserver(function (list) { list.getEntries().forEach(cb); });
        var cfg = { type: type, buffered: true };
        if (extra) for (var k in extra) cfg[k] = extra[k];
        po.observe(cfg);
      } catch (e) {}
    };
    obs('largest-contentful-paint', function (e) { m.lcp = Math.round(e.startTime); });
    var win = 0;
    var first = 0;
    var last = 0;
    obs('layout-shift', function (e) {
      if (e.hadRecentInput) return;
      if (win && e.startTime - last < 1000 && e.startTime - first < 5000) {
        win += e.value;
      } else {
        win = e.value;
        first = e.startTime;
      }
      last = e.startTime;
      if (win > m.cls) m.cls = win;
    });
    var longest = {};
    obs('event', function (e) {
      if (!e.interactionId) return;
      var d = e.duration;
      if (!longest[e.interactionId] || d > longest[e.interactionId]) longest[e.interactionId] = d;
      var max = 0;
      for (var id in longest) if (longest[id] > max) max = longest[id];
      m.inp = Math.round(max);
    }, { durationThreshold: 40 });

    var ua = navigator.userAgent || '';
    var iab = /Instagram|FBAN|FBAV|FB_IAB/i.test(ua);
    var mainEl = doc.querySelector('main[data-template]');
    var tmpl = mainEl ? mainEl.getAttribute('data-template') : '';
    var report = function () {
      if (sent) return;
      sent = true;
      var base = { template: tmpl, iab: iab ? 1 : 0, page: window.location.pathname };
      var out = [];
      if (m.lcp != null) out.push(['LCP', m.lcp]);
      out.push(['CLS', Math.round(m.cls * 1000) / 1000]);
      if (m.inp != null) out.push(['INP', m.inp]);
      out.forEach(function (row) {
        var p = { metric: row[0], value: row[1], template: base.template, iab: base.iab };
        try {
          if (typeof window.gtag === 'function') window.gtag('event', 'web_vitals', p);
          else if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'web_vitals', web_vitals: p });
        } catch (e) {}
        try { doc.dispatchEvent(new CustomEvent('cv:vitals', { detail: p })); } catch (e) {}
      });
    };
    doc.addEventListener('visibilitychange', function () {
      if (doc.visibilityState === 'hidden') report();
    });
    window.addEventListener('pagehide', report);
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    initDetailsSheets();
    initBagLabel();
    initMega();
    try { initContactLinks(); } catch (e) {}
    initRum();
    // declarative triggers: <button data-cv-open="#size-sheet">
    doc.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cv-open]') : null;
      if (!t) return;
      var target = resolve(t.getAttribute('data-cv-open'));
      if (target) {
        e.preventDefault();
        open(target, { trigger: t });
      }
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
